import React, { useEffect, useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { getImages } from '../Const';

const DownloadBuilder = ({ pdfRef, values }) => {

    const [formattedLocationValue, setFormattedLocationValue] = useState("");
    const [formattedPromoBannerValue, setFormattedPromoBannerValue] = useState("");

    // Function to format the address
    const formatAddress = (address) => {
        if (address.includes(",") && address.split(",").length >= 2) {
            const parts = address.split(",");

            const streetAndCity = parts[0].trim();
            const stateZip = parts[1].trim();

            const [state, zip] = stateZip.split(" ");

            const streetParts = streetAndCity.split(" ");

            const cityWordsCount = 2;
            const city = streetParts.slice(-cityWordsCount).join(" ");
            const street = streetParts.slice(0, -cityWordsCount).join(" ");

            return `${street}<br/>${city}, ${state} ${zip}`;
        }
        return address;
    };

    useEffect(() => {
        const formattedPromoBanner = formatAddress(values.promoBanner.value);
        const formattedLocation = formatAddress(values.locations.value);

        setFormattedPromoBannerValue(formattedPromoBanner);
        setFormattedLocationValue(formattedLocation);
    }, [values.promoBanner.value, values.locations.value]); // Trigger effect if either address changes

    return (
        <>
            {/* {console.log("values", values)} */}
            <div>
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between",
                            
                        }}
                    >
                        <div>
                            <img style={{width: "109px"}} src={getImages('cardrop-pdf-logo.png')} />
                        </div>
                        <div>
                            <div
                                style={{
                                    fontSize: "30px",
                                    fontWeight: "900",
                                    letterSpacing: "-0.13px",
                                    textAlign: "right",
                                    color: "#666",
                                    textTransform: "uppercase",
                                    fontFamily: "Roboto, Arial",
                                    lineHeight:"45px",
                                    
                                }}
                            >Appraisal Offer</div>
                            <div
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    fontStretch: "normal",
                                    fontStyle: "normal",
                                    lineHeight: "1.33",
                                    letterSpacing: "-0.19px",
                                    textAlign: "right",
                                    color: "#10758d",
                                    lineHeight:"20px",
                                    
                                }}
                            >www.cardropsouthflorida.com</div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex"
                        }}
                    >
                        <div
                            style={{
                                width: "360px",
                                paddingRight: "20px"
                            }}
                        >
                            <div
                                style={{
                                    border: "solid 1px #10758d",
                                    marginTop: "20px"
                                }}
                            >
                                <div
                                    style={{
                                        padding: "9px 15px",
                                        backgroundColor: "#10758d",
                                        fontSize: "12px",
                                        lineHeight: "18px",
                                        fontWeight: "bold",
                                        letterSpacing: "-0.08px",
                                        color: "#fff",
                                        display: "flex",
                                        textTransform: "uppercase",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        
                                    }}
                                >
                                    <div>Customer Info</div>
                                    <div>
                                        <span><img src={getImages('ap-info.svg')} /></span>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        padding: "10px 0",

                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        {values.full_name.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                        lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "62px",
                                                            
                                                        }}
                                                    >Name:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.full_name.fontSize + 'px',
                                                            // color: values.full_name.color,
                                                            fontSize: "12px",
                                                            lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "4px 16px 4px 6px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "213px",
                                                            textAlign: "right",
                                                            textTransform: "capitalize",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                overflow: "hidden",
                                                                whiteSpace:"nowrap",
                                                            }}
                                                        >
                                                            {values.full_name?.value?.toLowerCase()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {values.email.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "62px",
                                                            
                                                        }}
                                                    >Email:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.email.fontSize + 'px',
                                                            // color: values.email.color,
                                                            fontSize: "12px",
                                                            lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "213px",
                                                            textAlign: "right",
                                                            textTransform: "lowercase",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                overflow: "hidden",
                                                                whiteSpace:"nowrap",
                                                            }}
                                                        >
                                                            {values.email.value}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {values.phone.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                        lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "37%",
                                                            
                                                        }}
                                                    >Phone:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.phone.fontSize + 'px',
                                                            // color: values.phone.color,
                                                            fontSize: "12px",
                                                        lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "63%",
                                                            overflow: "hidden",
                                                            whiteSpace:"nowrap",
                                                            textAlign: "right",
                                                        }}
                                                    >{values.phone.value}</div>
                                                </div>
                                            </div>
                                        }
                                        {values.appraisal_date.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "100%",
                                                }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                        lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 6px 5px 16px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "50%",
                                                            
                                                        }}
                                                    >Date of Appraisal:</div>
                                                    <div
                                                        style={{
                                                            // fontSize: values.appraisal_date.fontSize + 'px',
                                                            // color: values.appraisal_date.color,
                                                            fontSize: "12px",
                                                        lineHeight: "18px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            padding: "5px 16px 5px 6px",
                                                            fontFamily: "Roboto, Arial",
                                                            width: "50%",
                                                            overflow: "hidden",
                                                            whiteSpace:"nowrap",
                                                            textAlign: "right",
                                                        }}
                                                    >{values.appraisal_date.value}</div>
                                                </div>
                                            </div>
                                        }
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    margin: "3px 0",
                                                    
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "10px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.06px",
                                                        color: "#10758d",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        textTransform: "uppercase",
                                                        paddingRight: "20px"
                                                    }}
                                                >Vehicle Information</div>
                                                <div
                                                    style={{
                                                        height: "1px",
                                                        background: "#cccccc",
                                                        width: "calc(100% - 160px)",
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        {/* Year: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "37%",
                                                        
                                                    }}
                                                >Year:</div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "4px 16px 5px 6px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace:"nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.year.value}</div>
                                            </div>
                                        </div>
                                        {/* Make: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "37%",
                                                        
                                                    }}
                                                >Make:</div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace:"nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.make.value}</div>
                                            </div>
                                        </div>
                                        {/* Model: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "37%",
                                                        
                                                    }}
                                                >Model:</div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace:"nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.model.value}</div>
                                            </div>
                                        </div>
                                        {/* Miles: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "37%",
                                                        
                                                    }}
                                                >Miles:</div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace:"nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.mileage?.value === '0' ? "" : values.mileage?.value}</div>
                                            </div>
                                        </div>
                                        {/* VIN: */}
                                        <div
                                            style={{
                                                flex: "0 0 auto",
                                                width: "100%",
                                            }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 6px 5px 16px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "37%",
                                                        
                                                    }}
                                                >VIN:</div>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "18px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        padding: "5px 16px 5px 6px",
                                                        fontFamily: "Roboto, Arial",
                                                        width: "63%",
                                                        overflow: "hidden",
                                                        whiteSpace:"nowrap",
                                                        textAlign: "right",
                                                    }}
                                                >{values.vin.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    border: "solid 1px #10758d",
                                    marginTop: "20px"
                                }}
                            >
                                <div
                                    style={{
                                        padding: "9px 15px",
                                        backgroundColor: "#10758d",
                                        fontSize: "12px",
                                        lineHeight: "18px",
                                        fontWeight: "bold",
                                        letterSpacing: "-0.08px",
                                        color: "#fff",
                                        display: "flex",
                                        textTransform: "uppercase",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        
                                    }}
                                >
                                    <div>Appraisal Details</div>
                                </div>
                                <div
                                    style={{

                                        paddingTop: "14px",
                                        paddingBottom: "14px",

                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            padding: "0 15px"
                                        }}
                                    >
                                        <div
                                            style={{
                                                borderRight: "solid 1px #10758d",
                                                flex: "0 0 auto",
                                                width: "50%",
                                            }}
                                        >

                                            {values.expiration_date.enabled &&
                                                <>
                                                    <div
                                                        style={{
                                                            fontSize: "12px",
                                                            lineHeight: "21px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#10758d",
                                                            textTransform: "uppercase",
                                                            marginBottom: "4px",
                                                            fontFamily: "Roboto, Arial",
                                                            textAlign: "center",
                                                            
                                                        }}
                                                    >Offer Valid Until</div>
                                                    <div
                                                        style={{
                                                            fontSize: "24px",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.08px",
                                                            color: "#3f404c",
                                                            fontWeight: "bold",
                                                            letterSpacing: "-0.09px",
                                                            fontFamily: "Roboto, Arial",
                                                            textAlign: "center",
                                                            minHeight: '36px'
                                                        }}
                                                    >{values.expiration_date.value}</div>
                                                </>
                                            }
                                        </div>
                                        {values.appraisal.enabled &&
                                            <div
                                                style={{
                                                    flex: "0 0 auto",
                                                    width: "50%",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "21px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#10758d",
                                                        textTransform: "uppercase",
                                                        marginBottom: "4px",
                                                        fontFamily: "Roboto, Arial",
                                                        textAlign: "center",
                                                        
                                                    }}
                                                >Appraisal Value</div>
                                                <div
                                                    style={{
                                                        fontSize: "24px",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.08px",
                                                        color: "#3f404c",
                                                        fontWeight: "bold",
                                                        letterSpacing: "-0.09px",
                                                        fontFamily: "Roboto, Arial",
                                                        textAlign: "center",
                                                    }}
                                                >{values.appraisal.value === '$0' ? "" : values.appraisal.value}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {values.vehicle_condition.enabled &&
                                <div
                                    style={{
                                        marginTop: "15px",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            letterSpacing: "-0.08px",
                                            color: "#10758d",
                                            textTransform: "uppercase",
                                            marginBottom: "2px",
                                            fontFamily: "Roboto, Arial",
                                            lineHeight: "21px",
                                        }}
                                    >Vehicle Condition</div>
                                    <div 
                                        style={{
                                            padding: "0px"
                                        }}
                                    >
                                        <div 
                                            style={{ 
                                                fontSize: "5px",
                                                color: "#3f404c",
                                                fontWeight: "400",
                                                letterSpacing: "-0.06px",
                                                marginBottom: "5px",
                                                fontFamily: "Roboto, Arial",
                                                height: '31px',
                                                overflow: 'hidden',
                                                lineHeight: '15px',
                                                whiteSpace: 'pre-line'
                                            }}>{values.vehicle_condition.value}</div>
                                    </div>
                                </div>
                            }
                            {values.appraisal_note.enabled &&
                                <div
                                    style={{
                                        marginTop: "0",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            letterSpacing: "-0.08px",
                                            color: "#10758d",
                                            textTransform: "uppercase",
                                            marginBottom: "2px",
                                            fontFamily: "Roboto, Arial",
                                            lineHeight: "21px",
                                        }}
                                    >APPRAISAL DETAILS</div>
                                    <div 
                                        style={{
                                            padding: "0px"
                                        }}
                                    >
                                        <div 
                                            style={{
                                                fontSize: "7px",
                                                color: "#3f404c",
                                                fontWeight: "400",
                                                letterSpacing: "-0.06px",
                                                marginBottom: "0",
                                                fontFamily: "Roboto, Arial",
                                                height: '59px',
                                                overflow: 'hidden',
                                                lineHeight: '15px',
                                                whiteSpace: 'pre-line',
                                            }}>{values.appraisal_note.value}</div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div
                            style={{
                                width: "160px",
                                minWidth: "160px",
                            }}
                        >
                            {values.locations.enabled &&
                                <>
                                    <div
                                        style={{
                                            border: "solid 1px #10758d",
                                            marginTop: "20px",
                                            
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "10px 15px",
                                                backgroundColor: "#10758d",
                                                fontSize: "11px",
                                                lineHeight: "15px",
                                                fontWeight: "bold",
                                                letterSpacing: "0.4px",
                                                color: "#fff",
                                                display: "flex",
                                                textTransform: "uppercase",
                                                alignItems: "center",
                                                justifyContent: "space-between"
                                            }}
                                        >
                                            <div>Locations</div>
                                            <div>
                                                <span>
                                                    <img
                                                        style={{
                                                            maxWidth: "15px"
                                                        }}
                                                        src={getImages('pin.png')} />
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                padding: "8px"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    lineHeight: "16px",
                                                    fontWeight: "bold",
                                                    letterSpacing: "-0.08px",
                                                    color: "#10758d",
                                                    textTransform: "uppercase",
                                                    marginBottom: "5px",
                                                    fontFamily: "Roboto, Arial",
                                                }}
                                            >Boyton Beach</div>
                                            <div
                                                style={{
                                                    fontSize: "10px",
                                                    lineHeight: "15px",
                                                    fontWeight: "400",
                                                    letterSpacing: "-0.06px",
                                                    color: "#3f404c",
                                                    fontFamily: "Roboto, Arial",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                2027 High Ridge Road Boynton <br/>Beach, FL 33426
                                            </div>
                                            <table
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}
                                                        >Mon - Sat:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>10:00am - 6:00pm</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Phone:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(561) 733-9919</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Fax:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(561) 733-8297</td>
                                                    </tr>
                                                </thead>
                                            </table>

                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    lineHeight: "16px",
                                                    fontWeight: "bold",
                                                    letterSpacing: "-0.08px",
                                                    color: "#10758d",
                                                    textTransform: "uppercase",
                                                    marginBottom: "5px",
                                                    fontFamily: "Roboto, Arial",
                                                    marginTop: "19px"
                                                }}
                                            >POMPANO BEACH</div>
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    lineHeight: "15px",
                                                    fontWeight: "400",
                                                    letterSpacing: "-0.06px",
                                                    color: "#3f404c",
                                                    fontFamily: "Roboto, Arial",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                3541 NW 14th Ave <br/>Pompano Beach, FL 33064
                                            </div>
                                            <table
                                                style={{
                                                    width: "100%"
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Mon - Sat:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#666666",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>10:00am - 6:00pm</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Phone:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(954) 366-1757</td>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "40%",
                                                                padding: "3px 0",
                                                                textAlign: "left"
                                                            }}>Fax:</th>
                                                        <td
                                                            style={{
                                                                fontFamily: "Roboto, Arial",
                                                                fontSize: "9px",
                                                                lineHeight: "13px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "-0.06px",
                                                                color: "#10758d",
                                                                width: "60%",
                                                                padding: "3px 0",
                                                                textAlign: "right"
                                                            }}>(954) 247-9970</td>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            }
                            {values.promoBanner.enabled &&
                                <>
                                    <div
                                        style={{
                                            marginTop: "15px",
                                            
                                        }}
                                    >
                                        <img
                                            style={{
                                                width: "100%"
                                            }}
                                            src={getImages('ap-banner1.png')} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div
                        style={{
                            marginTop: "5px",
                            
                        }}
                    >
                        <p
                            style={{
                                fontSize: "9px",
                                fontWeight: "normal",
                                lineHeight: "normal",
                                letterSpacing: "-0.04px",
                                color: "#999",
                            }}
                        >Disclaimer: All sales subject to final inspection</p>
                    </div>
            </div>
        </>
    );
};

export default DownloadBuilder;
